import React, { useEffect, useRef, useState } from "react";
import {
  Form,
  Input,
  Spin,
  Select,
  InputNumber,
  Divider,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { save } from "../../features/save/saveSlice";
import BreadCrumb from "../../layout/BreadCrumb";  
import PhoneInput from "react-phone-input-2";
import { agencyTypeData } from "../../data";

const StateAgencyAdd = () => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { saving } = useSelector((state) => state.save); 
  const { activeObjStateAgency } = useSelector((state) => ({
    activeObjStateAgency: state.obj.activeObj["stateAgency"],
  }));

  const dispatch = useDispatch();
  const navigate = useNavigate();

  function handleCancel() {
    navigate("/state-agency");
  }
  
  const onFinish = async (data) => {
    data.agencyId = activeObjStateAgency?.agencyId
      ? activeObjStateAgency?.agencyId
      : null;
    const res = await dispatch(
      save({
        ...data,
        url: "api/v2/stateAgency/save",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await form.resetFields();
      await handleCancel();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      ...activeObjStateAgency,
    });
  }, [activeObjStateAgency, form]);

  const initialFormValues = {
    ...activeObjStateAgency,
  };
 

  return (
    <div className="w-full ">
      <BreadCrumb
        breadcrumbs={[
          { title: "State Agencies", path: "/state-agency" },
          { title: "State Agency Add Form" },
        ]}
      />
      <div className="white_card mt-[2.06rem]">
        <div className="form-add-h mb-[1.25rem]">Add a New State Agency</div>
        <Divider />
        <div className="w-full mt-[1.75rem]">
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            className=""
            style={{
              maxWidth: "100%",
            }}
            form={form}
            initialValues={initialFormValues}
          >
            <div className="custom-title">Basic Information</div>
            <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
              <Form.Item
                name="agencyType"
                className=""
                label={"State Agency"}
                rules={[
                  {
                    required: true,
                    message: "Please select state agency",
                  },
                ]}
              >
                <Select
                  className=""
                  allowClear
                  style={{
                    width: "100%",
                  }}
                  options={
                    agencyTypeData?.length > 0 &&
                    agencyTypeData?.map((item) => ({
                      value: item?.value,
                      label: item?.label,
                    }))
                  }
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label?.toLocaleLowerCase() ?? "").includes(
                      input?.toLocaleLowerCase()
                    )
                  }
                />
              </Form.Item>
              <Form.Item
                name="agencyName"
                label={"Agency Name"}
                rules={[
                  {
                    required: true,
                    message: "Please add agency name",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
              <Form.Item
                name="agencyOfficePhone"
                label={"Office Phone Number"}
                rules={[
                  {
                    required: true,
                    message: "Please add office phone no",
                  },
                ]}
              >
                <PhoneInput
                  country="ke"
                  onlyCountries={["ke"]}
                  countryCodeEditable={false}
                  className="input rounded-[6px] border !border-[#cacaca] !h-[42px]"
                />
              </Form.Item>
              <Form.Item
                name="agencyOfficialEmail"
                label={"Official Email"}
                rules={[
                  {
                    required: true,
                    message: "Please add official email address",
                  },
                  {
                    type: "email",
                    message: "Please enter a valid email address",
                  },
                ]}
              >
                <Input type="email" className="input" />
              </Form.Item>
              <Form.Item
                name="agencyMdOrCeoName"
                label={"MD/CEO Name"}
                rules={[
                  {
                    required: true,
                    message: "Please add MD/CEO name",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
            </div>

            <div className="custom-title mt-[2.5rem]">Contact Person</div>
            <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
              <Form.Item
                name="agencyContactPersonName"
                label={"Name"}
                rules={[
                  {
                    required: false,
                    message: "Please add name",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
              <Form.Item
                name="agencyContactPersonIdNumber"
                label="ID Number"
                rules={[
                  {
                    required: false,
                    message: "National ID is required",
                  },
                  {
                    validator(_, value) {
                      if (value && value.toString().length < 6) {
                        return Promise.reject(
                          "National ID must be at least 6 characters long"
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <InputNumber
                 
                  parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                  className="input flex"
                />
              </Form.Item>
              <Form.Item
                name="agencyContactPersonPhone"
                label={"Phone"}
                rules={[
                  {
                    required: false,
                    message: "Please add phone no",
                  },
                ]}
              >
                <PhoneInput
                  country="ke"
                  onlyCountries={["ke"]}
                  countryCodeEditable={false}
                  className="input rounded-[6px] border !border-[#cacaca] !h-[42px]"
                />
              </Form.Item>
              <Form.Item
                name="agencyContactPersonEmail"
                label={"Admin Email"}
                rules={[
                  {
                    required: true,
                    message: "Please add admin email address",
                  },
                  {
                    type: "email",
                    message: "Please enter a valid email address",
                  },
                ]}
              >
                <Input type="email" className="input" />
              </Form.Item>
            </div>

            <div className="custom-title mt-[2.5rem]">Location</div>
            <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
            <Form.Item
                name="agencyPhysicalLocation"
                label={"Physical Location"}
                rules={[
                  {
                    required: false,
                    message: "Please add physical location",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
              <Form.Item
                name="agencyStreet"
                label={"Street"}
                rules={[
                  {
                    required: false,
                    message: "Please add street",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
              <Form.Item
                name="agencyBuilding"
                label={"Building"}
                rules={[
                  {
                    required: false,
                    message: "Please add building",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
              <Form.Item
                name="agencyCity"
                label={"City"}
                rules={[
                  {
                    required: false,
                    message: "Please add city",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item>
              {/* <Form.Item
                name="agencySecretariat"
                label={"Secretariat"}
                rules={[
                  {
                    required: false,
                    message: "Please add Secretariat",
                  },
                ]}
              >
                <Input className="input" />
              </Form.Item> */}
            </div>

            <div className="flex justify-between mt-[48px] ">
              <div className="justify-start"></div>
              <div className="justify-end flex items-center mb-[58px] gap-x-5">
                <div className="w-[150px]">
                  <button
                    type="button"
                    key="back"
                    onClick={handleCancel}
                    className="cstm-btn"
                  >
                    Cancel
                  </button>
                </div>

                <div className="w-[150px]">
                  <button key="submit" type="submit" className="cstm-btn-2">
                    {saving ? (
                      <Spin />
                    ) : activeObjStateAgency?.usrId ? (
                      "Update"
                    ) : (
                      "Register"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};
export default StateAgencyAdd;
